import React, { createContext, useContext, useMemo } from 'react';
import { useSettings } from './SettingsContext';
import { getTranslations } from '../i18n';

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const { settings, setSettings } = useSettings();
  const language = settings.language || 'pt-BR';

  const t = useMemo(() => getTranslations(language), [language]);

  const setLanguage = (lang) => setSettings({ language: lang });

  const value = useMemo(
    () => ({ t, language, setLanguage }),
    [t, language]
  );

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    return {
      t: getTranslations('pt-BR'),
      language: 'pt-BR',
      setLanguage: () => {},
    };
  }
  return ctx;
}
